import React from 'react'
import { Add } from '@mui/icons-material'
import { withRouter } from 'react-router-dom'

const AddUnitCallout = ({
  blockStatus,
  handleAddUnitCallout,
  enrollingForFirstTime,
  history
}) => {
  return (
    <div className="mobile-margin">
      <div className="calloutBox">
        <div className="calloutBox__content">
          <div className="row">
            <div className="col-xs-12 col-md-8">
              {blockStatus ? (
                <p style={{textAlign: 'left'}}>
                  If you wish to enrol in units outside of the blocks or
                  semesters defined above, click the blue '
                  <strong>Add unit</strong>' button.
                </p>
              ) : (
                <p style={{textAlign: 'left'}}>
                  To search and add units to enrol, click the '
                  <strong>Add unit</strong>' button.
                </p>
              )}
            </div>

            <div className="col-xs-12 col-md-4">
              <button
                className="btn btn-secondary btn-add add-unit-btn"
                onClick={() => handleAddUnitCallout()}
              >
                <Add className="btn-point-events" /> <span>Add unit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(AddUnitCallout)
